import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { t } from 'i18next'
import { type ReactNode } from 'react'
import { useFormContext } from 'react-hook-form'

export interface LaneOrRegionActionsProps {
  disabled: boolean
  onAction: () => void
  onClose: () => void
}

const LaneOrRegionDialogActions = ({
  disabled,
  onAction,
  onClose,
}: LaneOrRegionActionsProps): ReactNode => {
  const { formState } = useFormContext()

  return (
    <Stack direction="row" spacing={1} justifyContent="end">
      <Button
        color="secondary"
        variant="outlined"
        onClick={onClose}
      >
        {t('general.cancel')}
      </Button>
      <Button
        type="submit"
        color="secondary"
        variant="contained"
        loading={formState.isSubmitting}
        disabled={disabled}
        onClick={onAction}
      >
        {t('general.save')}
      </Button>
    </Stack>
  )
}

export default LaneOrRegionDialogActions
